import React from 'react'

import Layout from '../components/layout'
import HomeTwo from '../components/home/HomeTwo'
import ServiceCapabilities from '../components/services/ServiceCapabilities'
import ServiceOneTeam from '../components/services/ServiceOneTeam'
import ServiceOtherSolutions from '../components/services/ServiceOtherSolutions'
import ServicePageHero from '../components/services/ServicePageHero'
import { CYBER_SECURITY_CAPABILITIES_EN } from '../constants/serviceCapabilitiesCyberSecurity'
import { SERVICE_HERO_ASSETS, SERVICE_PAGE_PILLAR_ICONS } from '../constants/serviceHeroAssets'
import { SERVICE_ONE_TEAM_APPLICATION_EN } from '../constants/serviceOneTeamContent'
import { createServiceOtherSolutionsEn } from '../constants/serviceOtherSolutionsContent'

const CyberSecurityPageEn = () => (
  <Layout lang="en" title="Cyber Security" meta={{ description: '' }} rootProps={{ className: 'page services service-application-modernization' }}>
    <div className="service-detail-page">
      <ServicePageHero
        sectionId="service-hero"
        label="Services"
        title={'Cyber Security.'}
        description={
          'We safeguard your systems with proactive security strategies, continuous monitoring, and compliance-driven solutions.'
        }
        heroImage={SERVICE_HERO_ASSETS.security.src}
        imageAlt="Cyber security illustration"
        imageWidth={SERVICE_HERO_ASSETS.security.width}
        imageHeight={SERVICE_HERO_ASSETS.security.height}
        pillarIcon={SERVICE_PAGE_PILLAR_ICONS.security.src}
        pillarIconWidth={SERVICE_PAGE_PILLAR_ICONS.security.width}
      />
      <ServiceCapabilities
        idBase="service-capabilities-cyber-security"
        sectionTitle="Capabilities built for Security & Trust."
        tabs={CYBER_SECURITY_CAPABILITIES_EN}
        contactCtaIsEn
      />
      <HomeTwo lang="en" />
      <ServiceOneTeam
        idBase="service-one-team-cyber-security"
        {...SERVICE_ONE_TEAM_APPLICATION_EN}
      />
      <ServiceOtherSolutions
        idBase="service-other-solutions-cyber-security"
        {...createServiceOtherSolutionsEn('cyber')}
      />
    </div>
  </Layout>
)

export default CyberSecurityPageEn
